import React from 'react'

export const IosAppStoreButton = ({ url, description = 'Link to App store' }) => {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <img className="m-3  " alt={description} src="/assets/img/ios_button.png" />
    </a>
  )
}
